export class MessageInfo {

  public accessChannel    : string = "WEB";
  public language         : string = "Fr";
  public transactionTime  : Date = new Date();
  public userLocation     : string;
  public appRelease       : number = 10;
  public reference        : string;

  constructor() {

  }

}
